import React from 'react';
import {Divider} from 'antd';

const InnerDivider = ({style, ...props}) => (
  <Divider style={{ marginTop: 8, marginBottom: 8, ...style }} {...props} />
);

export default InnerDivider;